import { ApplicationRef, Component, ElementRef, Inject, Renderer2, ViewChild, ViewContainerRef, DOCUMENT } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonService } from 'src/app/services/common/common.service';
import { ReportStatusModalComponent } from '../report-status-modal/report-status-modal.component';
import { RefundStatusModalComponent } from '../refund-status-modal/refund-status-modal.component';
import { CurrencySymbolConstant } from 'src/app/common/Constants/CurrencySymbolConstant';
import { ACTIVITY_TYPE, PASS_TYPE, REPORT_STATUS } from 'src/app/common/Constants/enums';
import { dateformat } from 'src/app/models/commonModel';
import { MatPaginator } from '@angular/material/paginator';
import { AddNewSessionDialogComponent } from '../add-new-session-dialog/add-new-session-dialog.component';
import * as moment from 'moment';
import { CustomerActivityLabelConstant } from 'src/app/constants/LabelConstants';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from 'src/app/component/confirmation-dialog/confirmation-dialog.component';
declare const google: any;

@Component({
    selector: 'app-customer-activities-dialog',
    templateUrl: './customer-activities-dialog.component.html',
    styleUrls: ['./customer-activities-dialog.component.scss'],
    standalone: false
})
export class CustomerActivitiesDialogComponent {

  isExpanded: { [key: number]: boolean } = {}; // Object to track expansion states for each div
  customerId: any;
  currentDate: Date = new Date();
  currencySymbolConstant: any;
  sessionList: any[] = [];
  eventList: any[] = [];
  reportList: any[] = [];
  refundList: any[] = [];
  dateFormat: { datetime: string; titleFormat: string; date: string; shortTime: string; };
  labelConstant: any;
  map: any;
  public PASS_TYPE = PASS_TYPE;

  // Session Activity Variables
  dataSourceSessionList: any = [];
  pageSessionList = 1;
  searchKeywordSessionList = '';
  pageSizeSessionList: number = 10;
  totalrecordSessionList: number = 0;
  currentPageSessionList: number = 0;
  sessionFromDate: any = null;
  sessionToDate: any = null;
  @ViewChild('paginatorSessionList') paginatorSessionList: MatPaginator | null = null;
  pageSizeOptionsSessionList: number[] = [5, 10, 25, 100];
  isReported: boolean = false;

  // Event Activity Variables
  dataSourceEventList: any = [];
  pageEventList = 1;
  searchKeywordEventList = '';
  pageSizeEventList: number = 10;
  totalrecordEventList: number = 0;
  currentPageEventList: number = 0;
  eventFromDate: any = null;
  eventToDate: any = null;
  @ViewChild('paginatorEventList') paginatorEventList: MatPaginator | null = null;
  pageSizeOptionsEventList: number[] = [5, 10, 25, 100];
  filterEventModalOpen: boolean = false;
  fromEventDate: any;
  toEventDate: any;
  otherEventIds: any;
  filterEventApplied: boolean;

  // Report Activity Variables
  dataSourceReportList: any = [];
  pageReportList = 1;
  searchKeywordReportList = '';
  pageSizeReportList: number = 10;
  totalrecordReportList: number = 0;
  currentPageReportList: number = 0;
  reportFromDate: any = null;
  reportToDate: any = null;
  @ViewChild('paginatorReportList') paginatorReportList: MatPaginator | null = null;
  pageSizeOptionsReportList: number[] = [5, 10, 25, 100];

  // Refund Activity Variables
  dataSourceRefundList: any = [];
  pageRefundList = 1;
  searchKeywordRefundList = '';
  pageSizeRefundList: number = 10;
  totalrecordRefundList: number = 0;
  currentPageRefundList: number = 0;
  refundFromDate: any = null;
  refundToDate: any = null;
  @ViewChild('paginatorRefundList') paginatorRefundList: MatPaginator | null = null;
  pageSizeOptionsRefundList: number[] = [5, 10, 25, 100];
  reportStatus: typeof REPORT_STATUS;
  selectedTabLabel: string = 'Session';

  fromDate: any;
  toDate: any;
  sessionTypes: any = [];
  reportFilterTypes: any = [];
  @ViewChild('modal') modal;

  sessionTypeList: any = [
    {
      value: 1,
      name: 'Upcoming'
    },
    {
      value: 2,
      name: 'Booked'
    },
    {
      value: 3,
      name: 'Sold Out'
    }
  ];

  reportTypeList: any = [
    {
      value: 1,
      name: 'In Progress'
    },
    {
      value: 2,
      name: 'Reject'
    },
    {
      value: 4,
      name: 'Approve'
    }
  ];

  constructor(
    private dialogRef: MatDialogRef<CustomerActivitiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private api: ApiUrlHelper,
    private commonService: CommonService,
    private renderer2: Renderer2,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    public viewRef: ViewContainerRef,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.currencySymbolConstant = CurrencySymbolConstant;
    this.labelConstant = CustomerActivityLabelConstant;
    this.reportStatus = REPORT_STATUS;
    this.dateFormat = dateformat;
    this.getSessionList();
  }

  checkExpiry(item): boolean {
    return new Date(item.expireOn) < this.currentDate;
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabLabel = '';
    this.selectedTabLabel = event.tab.textLabel || '';
    this.clearAllFilter();
    this.spinner.show()
    if (event.index == ACTIVITY_TYPE.SESSIONS) {
      this.getSessionList();
    }
    else if (event.index == ACTIVITY_TYPE.EVENTS) {
      this.getEventList();
    }
    else if (event.index == ACTIVITY_TYPE.REPORT) {
      this.getReportList();
    }
    else if (event.index == ACTIVITY_TYPE.REFUND) {
      this.getRefundList();
    }
    this.closeFilter()
  }

  getSessionList() {
    this.spinner.show();
    let obj = {
      pageNumber: this.currentPageSessionList + 1,
      pageSize: this.pageSizeSessionList,
      strSearch: this.searchKeywordSessionList,
      allUser: false,
      customerId: this.customerId,
      fromDate: this.sessionFromDate,
      toDate: this.sessionToDate,
      otherIds: this.sessionTypes.join(',')
    }
    this.sessionList = [];
    let api = this.api.apiUrl.CustomerActivities.GetCustomerSessionList;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.sessionList = response.data;
          if (this.sessionList.length > 0) {
            this.totalrecordSessionList = response.data[0].totalRecords ? response.data[0].totalRecords : 0;
            setTimeout(() => {
              this.paginatorSessionList.pageIndex = this.currentPageSessionList;
              this.paginatorSessionList.length = this.totalrecordSessionList;
            });
          }
          else {
            this.totalrecordSessionList = 0;
          }
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.sessionList = [];
          this.totalrecordSessionList = 0;
          this.toastr.error(response.message);
        }
      },
      error(err) {
        this.spinner.hide();
        console.log(err);
      },
    });
  }

  openPicker(picker: any) {
    picker.open();
  }

  earlyCancel(element: any) {
    const start = this.datePipe.transform(element.sessionStartDateTime, 'h:mma');
    const end = this.datePipe.transform(element.sessionEndDateTime, 'h:mma');
    const date = this.datePipe.transform(element.sessionStartDateTime, 'EEE d MMM yyyy');

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: { action: `${element.className}`, heading: "Cancel Session", date: ` (${start} – ${end} | ${date})`, isSession: true },
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.spinner.show();
        let obj = {
          OrderDetailId: element.orderDetailId,
          ClassSessionId: element.classSessionId,
          SessionBookIds : element.sessionBookId
        }
        let api = this.api.apiUrl.Orders.EarlyCancel;
        this.commonService.doPost(api, obj).pipe().subscribe({
          next: (response) => {
            if (response.success) {
              this.spinner.hide();
              this.getSessionList();
              this.toastr.success(response.message);

            } else {
              this.spinner.hide();
              this.toastr.error(response.message);
            }
          },
          error(err) {
            this.spinner.hide();
            console.log(err);
          },
        });
      }
    });
  }

  isEarlyCancelAvailable(date) {
    const inputDate = new Date(date);

    // Get the current system date and time
    const currentDate = new Date();

    // Compare the dates including the time
    return inputDate > currentDate;
  }

  getEventList() {
    this.spinner.show();
    let obj = {
      pageNumber: this.currentPageEventList + 1,
      pageSize: this.pageSizeEventList,
      strSearch: this.searchKeywordEventList,
      allUser: false,
      customerId: this.customerId,
      fromDate: this.eventFromDate,
      toDate: this.eventToDate,
      otherIds: ""
    }
    this.eventList = [];
    let api = this.api.apiUrl.CustomerActivities.GetCustomerEventList;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.eventList = response.data;
          if (this.eventList.length > 0) {
            this.totalrecordEventList = response.data[0].totalRecords ? response.data[0].totalRecords : 0;
            setTimeout(() => {
              this.paginatorEventList.pageIndex = this.currentPageEventList;
              this.paginatorEventList.length = this.totalrecordEventList;
            });

            const url = `https://maps.googleapis.com/maps/api/js?key=${environment.G_APIKey}&libraries=places`;
            const script = this.document.getElementById("scriptAutocomplete");
            if (script) {
              script.remove();
            }
            this.loadScript(url).then(() => {
              this.eventList.forEach(event => {
                const mapOptions = {
                  center: { lat: event.latitude, lng: event.logitude },
                  zoom: 16
                };
                const mapElement = document.getElementById(`map-${event.orderId}`);
                const map = new google.maps.Map(mapElement, mapOptions);
                new google.maps.Marker({
                  position: { lat: event.latitude, lng: event.logitude },
                  map: map,
                  title: event.name
                });
              });
            });

          }
          else {
            this.totalrecordEventList = 0;
          }
          this.spinner.hide();
        } else {
          this.eventList = [];
          this.totalrecordEventList = 0;
          this.spinner.hide();
          this.toastr.error(response.message);
        }
      },
      error(err) {
        this.spinner.hide();
        console.log(err);
      },
    });
  }

  getReportList() {
    this.spinner.show();
    let obj = {
      pageNumber: this.currentPageReportList + 1,
      pageSize: this.pageSizeReportList,
      strSearch: this.searchKeywordReportList,
      allUser: false,
      customerId: this.customerId,
      isRefundListOfCustomer: false,
      fromDate: this.reportFromDate,
      toDate: this.reportToDate,
      otherIds: this.reportFilterTypes.join(',')
    }
    this.reportList = [];
    let api = this.api.apiUrl.CustomerActivities.GetCustomerReportRefundList;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.reportList = response.data;
          if (this.reportList.length > 0) {
            this.totalrecordReportList = response.data[0].totalRecords ? response.data[0].totalRecords : 0;
            setTimeout(() => {
              this.paginatorReportList.pageIndex = this.currentPageReportList;
              this.paginatorReportList.length = this.totalrecordReportList;
            });
          }
          else {
            this.totalrecordReportList = 0;
          }
          this.spinner.hide();

        } else {
          this.spinner.hide();
          this.reportList = [];
          this.totalrecordReportList = 0;
          this.toastr.error(response.message);
        }
      },
      error(err) {
        this.spinner.hide();
        console.log(err);
      },
    });
  }

  getRefundList() {
    this.spinner.show();
    let obj = {
      pageNumber: this.currentPageRefundList + 1,
      pageSize: this.pageSizeRefundList,
      strSearch: this.searchKeywordRefundList,
      allUser: false,
      customerId: this.customerId,
      isRefundListOfCustomer: true,
      fromDate: this.refundFromDate,
      toDate: this.refundToDate,
      otherIds: ""
    }
    this.refundList = [];
    let api = this.api.apiUrl.CustomerActivities.GetCustomerReportRefundList;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.refundList = response.data;
          if (this.refundList.length > 0) {
            this.totalrecordRefundList = response.data[0].totalRecords ? response.data[0].totalRecords : 0;
            setTimeout(() => {
              this.paginatorRefundList.pageIndex = this.currentPageRefundList;
              this.paginatorRefundList.length = this.totalrecordRefundList;
            });
          }
          else {
            this.totalrecordRefundList = 0;
          }
          this.spinner.hide();

        } else {
          this.spinner.hide();
          this.refundList = [];
          this.totalrecordRefundList = 0;
          this.toastr.error(response.message);
        }
      },
      error(err) {
        this.spinner.hide();
        console.log(err);
      },
    });
  }

  pageChangedSession(event: any) {
    this.pageSizeSessionList = event.pageSize;
    this.currentPageSessionList = event.pageIndex;
    this.getSessionList();
  }

  pageChangedEvent(event: any) {
    this.pageSizeEventList = event.pageSize;
    this.currentPageEventList = event.pageIndex;
    this.getEventList();
  }

  pageChangedReport(event: any) {
    this.pageSizeReportList = event.pageSize;
    this.currentPageReportList = event.pageIndex;
    this.getReportList();
  }

  pageChangedRefund(event: any) {
    this.pageSizeRefundList = event.pageSize;
    this.currentPageRefundList = event.pageIndex;
    this.getRefundList();
  }

  applyFilter(event: any, index: any) {
    if (index == ACTIVITY_TYPE.SESSIONS) {
      if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
        this.currentPageSessionList = 0;
        this.getSessionList();
      }
    }
    else if (index == ACTIVITY_TYPE.EVENTS) {
      if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
        this.currentPageEventList = 0;
        this.getEventList();
      }
    }
    else if (index == ACTIVITY_TYPE.REPORT) {
      if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
        this.currentPageReportList = 0;
        this.getReportList();
      }
    }
    else if (index == ACTIVITY_TYPE.REFUND) {
      if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
        this.currentPageRefundList = 0;
        this.getRefundList();
      }
    }
  }

  clearSearch(index: any) {
    if (index == ACTIVITY_TYPE.SESSIONS) {
      this.searchKeywordSessionList = '';
      this.getSessionList();
    }
    else if (index == ACTIVITY_TYPE.EVENTS) {
      this.searchKeywordEventList = '';
      this.getEventList();
    }
    else if (index == ACTIVITY_TYPE.REPORT) {
      this.searchKeywordReportList = '';
      this.getReportList();
    }
    else if (index == ACTIVITY_TYPE.REFUND) {
      this.searchKeywordRefundList = '';
      this.getRefundList();
    }
  }

  private loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.id = "scriptAutocomplete";
      script.src = url;
      script.text = ``;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer2.appendChild(this.document.head, script);
    })
  }

  addNewSession(data: any) {
    data.model = data.model.filter(item => item.isAddOnSession);
    const dialogRef = this.dialog.open(AddNewSessionDialogComponent, {
      width: '700px',
      data: {
      },
      disableClose: true,
      autoFocus: false
    });
    dialogRef.componentInstance.customerId = this.customerId;
    dialogRef.componentInstance.passData = data;
    dialogRef.afterClosed().subscribe((result) => {
      this.getSessionList();
    });
  }

  getDate(date) {
    let utcTime = moment.utc(date);
    const localTime = utcTime.local();
    return localTime
  }

  splitString(options: any): void {
    return options.split("^");
  }

  cancel() {
    this.dialogRef.close();
  }

  toggleExpand(id: number) {
    this.isExpanded[id] = !this.isExpanded[id];
    const buttonElement = document.getElementById('pass-view-btn-${id}');
    if (buttonElement) {
      buttonElement.classList.toggle('show');
    }
  }

  openReportStatus(reportRequestId: any) {
    const dialogRef = this.dialog.open(ReportStatusModalComponent, {
      width: '800px',
      data: {},
      disableClose: true,
      autoFocus: false
    });
    dialogRef.componentInstance.reportId = reportRequestId;
    dialogRef.afterClosed().subscribe((result) => {
      this.getReportList();
    });
  }

  openRefundStatus(reportRequestId: any) {
    const dialogRef = this.dialog.open(RefundStatusModalComponent, {
      width: '700px',
      data: {},
      disableClose: true,
      autoFocus: false
    });
    dialogRef.componentInstance.reportId = reportRequestId;
    dialogRef.afterClosed().subscribe((result) => {
      this.getRefundList();
    });
  }

  openEventFilter(eventFilterModal: any) {
    if (!this.filterEventModalOpen) {
      this.modalService.open(eventFilterModal,
        {
          ariaLabelledBy: 'modal-basic-title',
          modalDialogClass: 'delete-popup common-popup-ui',
          centered: true,
          backdrop: 'static',
          size: 'sm',
          scrollable: true,
        }).result.then((result) => {
          this.modalService.dismissAll();
        }, (reason) => {
        });
    }
  }


  close() {
    this.modalService.dismissAll()
  }

  formatDateTime(dateString: string, timeString: string): string {
    // Parse the date string
    const date = new Date(dateString);

    // Parse the time string
    const timeParts = timeString.split(":");
    let hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1].split(" ")[0]);
    const meridian = timeParts[1].split(" ")[1];

    // Adjust hours for AM/PM format
    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }

    date.setHours(hours, minutes);
    // Format the date and time as "YYYY-MM-DDTHH:mm:ss"
    const formattedDateTime = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss.SSS');
    return formattedDateTime;
  }

  sessionFilterView: boolean = false;
  eventFilterView: boolean = false;
  reportFilterView: boolean = false;
  refundFilterView: boolean = false;

  filterClick() {
    this.sessionFilterView = !this.sessionFilterView;
  }

  eventFilterClick() {
    this.eventFilterView = !this.eventFilterView;
  }

  reportFilterClick() {
    this.reportFilterView = !this.reportFilterView;
  }

  refundFilterClick() {
    this.refundFilterView = !this.refundFilterView;
  }

  clearAll() {
    this.sessionFromDate = null;
    this.sessionToDate = null;
    this.currentPageSessionList = 0;
    this.sessionTypes = [];
    this.getSessionList();
    this.sessionFilterView = false;
  }

  applySessionFilter() {
    this.sessionFromDate = this.formatDateTime(this.sessionFromDate, "12:00 AM");
    this.sessionToDate = this.formatDateTime(this.sessionToDate, "12:00 AM");
    this.currentPageSessionList = 0;
    this.getSessionList();
    this.sessionFilterView = false;
  }

  ApplyEventFilter() {
    this.eventFromDate = this.formatDateTime(this.eventFromDate, "12:00 AM");
    this.eventToDate = this.formatDateTime(this.eventToDate, "12:00 AM");
    this.currentPageEventList = 0;
    this.getEventList();
    this.eventFilterView = false;
  }

  clearEventFilterAll() {
    this.eventFromDate = null;
    this.eventToDate = null;
    this.currentPageEventList = 0;
    this.getEventList();
    this.eventFilterView = false;
  }


  closeFilter() {
    this.sessionFilterView = false;
    this.eventFilterView = false;
    this.reportFilterView = false;
    this.refundFilterView = false;
  }

  clearReportFilterAll() {
    this.reportFromDate = null;
    this.reportToDate = null;
    this.reportFilterTypes = [];
    this.currentPageReportList = 0;
    this.getReportList();
    this.reportFilterView = false;
  }

  clearRefundFilterAll() {
    this.refundFromDate = null;
    this.refundToDate = null;
    this.currentPageRefundList = 0;
    this.getRefundList();
    this.refundFilterView = false;
  }

  applyReportFilter() {
    this.reportFromDate = this.reportFromDate == null ? null : this.formatDateTime(this.reportFromDate, "12:00 AM");
    this.reportToDate = this.reportToDate == null ? null : this.formatDateTime(this.reportToDate, "12:00 AM");
    this.currentPageReportList = 0;
    this.getReportList();
    this.reportFilterView = false;
  }

  applyRefundFilter() {
    this.refundFromDate = this.refundFromDate == null ? null : this.formatDateTime(this.refundFromDate, "12:00 AM");
    this.refundToDate = this.refundToDate == null ? null : this.formatDateTime(this.refundToDate, "12:00 AM");
    this.currentPageRefundList = 0;
    this.getRefundList();
    this.refundFilterView = false;
  }

  checkTime(eventStartTime) {
    return new Date(eventStartTime) < new Date();
  }

  clearAllFilter() {
    this.sessionFromDate = null;
    this.sessionToDate = null;
    this.eventFromDate = null;
    this.eventToDate = null;
    this.reportFromDate = null;
    this.reportToDate = null;
    this.refundFromDate = null;
    this.refundToDate = null;
    this.reportFilterTypes = [];
  }

isAddOnSessionPresent(item: any): boolean {
  return item?.model?.some((element: any) => element.isAddOnSession) && item.typeOfPass != 7;
}

}